import { useChatContext } from '@/context/ChatContext';
import { AriaAvatar } from './AriaAvatar';
import { ChatPanel } from './ChatPanel';

export function ChatBubble() {
  const { isOpen, isMinimized, vehicle, maximizeChat } = useChatContext();

  // Not visible when no chat is active
  if (!isOpen) return null;

  // Minimized: floating bubble
  if (isMinimized) {
    return (
      <button
        onClick={maximizeChat}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3
          bg-gradient-to-r from-purple-600 to-pink-600 rounded-full shadow-lg
          hover:shadow-purple-500/25 hover:scale-105 transition-all cursor-pointer"
      >
        <AriaAvatar size={32} />
        {vehicle && (
          <span className="text-white text-sm font-medium max-w-[200px] truncate">
            {vehicle.year} {vehicle.make} {vehicle.model}
          </span>
        )}
        {/* Pulse indicator */}
        <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
      </button>
    );
  }

  // Expanded: full chat panel
  return (
    <div role="dialog" aria-label="ARIA conversation" className="fixed inset-0 z-50 w-full h-[100dvh]
      overflow-hidden shadow-2xl
      sm:inset-auto sm:bottom-4 sm:right-4 sm:w-[380px] sm:h-[calc(100dvh-2rem)] sm:rounded-2xl
      lg:w-[420px]">
      <ChatPanel />
    </div>
  );
}
